import React, {useEffect, useState} from 'react';
import {useLocation, Redirect} from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import {
  Button,
  Input,
  FormItem,
} from '@mayo/mayo-ui-gakki'
import SubHeader from '../components/SubHeader';
import {useAuthContext} from '../context/auth-context';
import FullPageLoader from '../components/FullPageLoader';
interface FormValues {
  newPassword: string;
  secondPassword: string;
}

export default function PasswordEnablePage() {
  const location = useLocation();
  const [isPasswordEnabled, setIsPasswordEnabled] = useState<boolean | null>(
    null,
  );
  const {setPassword, checkPasswordEnable, isFetching, isLogin, companyId} =
    useAuthContext();
  const codeRegex = /code=([^&]*)/;
  const code: string = location.search.match(codeRegex)?.[1] || '';
  const {control, formState, errors, handleSubmit, watch} = useForm<FormValues>(
    {
      defaultValues: {
        newPassword: '',
        secondPassword: '',
      },
    },
  );
  const newPasswordValue = watch('newPassword');

  const checkPassword = async (code: string) => {
    try {
      const isEnable = await checkPasswordEnable(code);
      if (isEnable) {
        window.location.href = `${window.location.origin}/gakki/login`;
      } else {
        setIsPasswordEnabled(isEnable);
      }
    } catch (error) {
      window.location.href = `${window.location.origin}/gakki/login`;
    }
  };
  useEffect(() => {
    checkPassword(code);
  }, []);

  const onSubmit = ({newPassword}: FormValues) => {
    return setPassword({newPassword, code});
  };

  if (isLogin && companyId) {
    return <Redirect to={'/gakki'} />;
  }
  if (isPasswordEnabled === null) {
    return <FullPageLoader />;
  }
  return (
    <React.Fragment>
      {isFetching && <FullPageLoader />}
      <div
        className={
          'flex justify-center items-center h-[calc(100vh-174px)] min-h-[520px]'
        }
      >
        <div
          className={
            'w-[440px] h-[441px] bg-white rounded border border-[#e3e4e6] px-4 relative flex flex-col justify-between'
          }
        >
          <div>
            <SubHeader className={'!h-[66.3px] !m-0'}>設定您的密碼</SubHeader>
            <div className={'grid pt-4 gap-4'}>
              <FormItem label="輸入密碼">
                <Controller
                  render={formProps => (
                    <Input
                      {...formProps}
                      type="password"
                      isError={Boolean(formState.isSubmitted && errors.newPassword)}
                      placeholder="密碼至少8碼、包含大寫、小寫字母及數字"
                    />
                  )}
                  name="newPassword"
                  control={control}
                  rules={{required: true}}
                />
              </FormItem>
              <FormItem
                label="再次輸入密碼"
                errorMessage={formState.isSubmitted && errors.secondPassword ? errors.secondPassword?.message : ''}
              >
                <Controller
                  render={formProps => (
                    <Input
                      {...formProps}
                      type="password"
                      isError={Boolean(
                        formState.isSubmitted && errors.secondPassword,
                      )}
                      placeholder="請再次輸入密碼"
                    />
                  )}
                  name="secondPassword"
                  control={control}
                  rules={{
                    required: true,
                    validate: {
                      isSamePassword: v => {
                        return newPasswordValue === v || '請輸入相同密碼';
                      },
                    },
                  }}
                />
              </FormItem>
            </div>
          </div>
          <div
            className={
              'h-[73.2px] border-t border-t-[#e9eced] py-[19px] flex justify-end'
            }
          >
            <Button
              variant={'solid'}
              colorSchema={'primary'}
              onClick={handleSubmit(onSubmit)}
              data-test-id={'confirm-btn'}
            >
              登入
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
